import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStopShareScreen: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="stop-share-screen, stop-sharing"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9 9L15 15M15 9L9 15" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconStopShareScreen;
